<template>
  <div class="invitacion-container">

    <!-- 🌸 CARD ENCIMA DEL VIDEO -->
    <div class="invitacion-card">

      <!-- SELLO (MOÑO) Y PÉTALOS -->
      <img src="@/assets/florbrillo.avif" class="sello-decorativo" />
      <img src="@/assets/florbrillo.avif" class="sello-decorativo sello-secundario" />
      
      <!-- NUEVOS PÉTALOS A LOS LADOS -->
      <img src="@/assets/petalos.png" class="petalo-decorativo petalo-izquierdo" />
      <img src="@/assets/petalos.png" class="petalo-decorativo petalo-derecho" />

      <h1 ref="titulo" class="titulo-principal"></h1>

      <p ref="nombres" class="subtitulo">
            <span class="inicial-script">R</span><span class="resto-nombre">EGINA EDITH</span>
      </p>

      <p ref="fecha" class="fecha">05 • Diciembre • 2026</p>

      <div class="seccion-idiomas" ref="idiomaSeccion">
        <p class="instruccion">Bienvenidos a mi invitación</p>

        <div class="opciones-idioma">
          <button @click="seleccionar('es')" class="btn-idioma">
            Ingresar
          </button>
          
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue';
import gsap from 'gsap';

export default {
  name: 'InvitacionIdioma',
  emits: ['idioma-seleccionado'],
  setup(_, { emit }) {
    const ramaIzquierda = ref(null);
    const ramaDerecha = ref(null);
    const titulo = ref(null);
    const nombres = ref(null);
    const ampersand = ref(null);
    const fecha = ref(null);
    const idiomaSeccion = ref(null);

    const seleccionar = (idioma) => {
      emit('idioma-seleccionado', idioma);
    };

    onMounted(() => {
      gsap.from(ramaIzquierda.value, {
        x: -200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
      });

      gsap.from(ramaDerecha.value, {
        x: 200,
        opacity: 0,
        duration: 1.5,
        ease: 'power3.out',
        delay: 0.3,
      });

      // Animación de entrada escalonada
      gsap.timeline({ delay: 0.5 })
        .from(titulo.value, {
          opacity: 0,
          y: -30,
          duration: 1,
          ease: 'power2.out',
        })
        .from(nombres.value, {
          opacity: 0,
          y: 30,
          duration: 1.2,
          ease: 'back.out(1.7)',
        }, '-=0.5')
        .from(ampersand.value, {
          scale: 0,
          opacity: 0,
          duration: 0.6,
          ease: 'elastic.out(1, 0.5)',
        }, '-=1')
        .from(fecha.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8')
        .from(idiomaSeccion.value, {
          opacity: 0,
          y: 20,
          duration: 1,
          ease: 'power2.out',
        }, '-=0.8');
    });

    return {
      seleccionar,
      ramaIzquierda,
      ramaDerecha,
      titulo,
      nombres,
      ampersand,
      fecha,
      idiomaSeccion,
    };
  }
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@400;600;700&family=Montserrat:wght@300;400;500&family=Dancing+Script:wght@700&display=swap');

/* ===== CONTENEDOR ===== */
.invitacion-container{
  position: relative;
  min-height: 100vh;
  display: flex;
  margin-top:-60px;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

/* ===== VIDEO DE FONDO ===== */
.video-fondo{
  position: fixed;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 0;

  /* efecto cinematográfico */
  filter: brightness(0.75) saturate(1.1);
}

/* ===== CARD VERDE ===== */
.invitacion-card{
  position: relative;
  z-index: 5;
  width: 100%;
  max-width: 380px;
  padding: 80px 22px 70px;
  border-radius: 0 80px 0 80px;
  text-align: center;

  /* verde elegante translúcido */
  background: #f0c9d3;

  backdrop-filter: blur(2px);

  box-shadow:
    0 18px 50px rgba(0,0,0,.25),
    0 6px 14px rgba(0,0,0,.15);
}

/* ===== SELLO ===== */
.sello-decorativo{
  position: absolute;
  top: -50px;
  left: 50%;
  transform: translateX(-50%) rotate(-1.5deg);
  width: min(26vw, 240px) !important;
  z-index: 6;
  opacity: 0.9;

  filter:
    drop-shadow(0 10px 18px rgba(0,0,0,0.25))
    saturate(0.85)
    brightness(1.05);

  pointer-events: none;
}

.sello-secundario{
  opacity: 0.5;
}

/* ===== NUEVOS ESTILOS PARA PÉTALOS ===== */
.petalo-decorativo {
  position: absolute;
  z-index: 5; /* Justo detrás o al nivel del moño */
  width: 120px !important; /* Ajusta el tamaño según necesites */
  height: auto;
  pointer-events: none;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.15));
}

.petalo-izquierdo {
  top: -20px; /* Ajusta la altura respecto al moño */
  left: -40px; /* Ajusta qué tan a la izquierda sale */
  transform: rotate(-15px); /* Rotación opcional */
}

.petalo-derecho {
  top: -20px; /* Ajusta la altura respecto al moño */
  right: -25px; /* Ajusta qué tan a la derecha sale */
  transform: scaleX(-1) rotate(-20px); /* Invertido horizontalmente y rotado */
}

/* ===== TEXTO ===== */
.titulo-principal{
  font-family: 'Dancing Script', cursive;
  font-size: 2.5rem;
  color: #ffffff;
}

.subtitulo{
  font-family: 'Dancing Script', cursive;
  font-size: 3rem !important;
  color: #ffffff;
  margin-top: -40px;
}

.fecha{
  font-family: 'Montserrat', sans-serif;
  font-size: 1.4rem;
  color: #ffffff;
  margin-bottom: 2rem;
}

/* ===== IDIOMAS ===== */
.seccion-idiomas{
  margin-top: 2rem;
}

.instruccion{
  font-family: 'Montserrat', sans-serif;
  font-size: 1rem;
  color: #ffffff;
  margin-bottom: 1.3rem;
}

.opciones-idioma{
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.btn-idioma{
  padding: 14px;
  border-radius: 14px;
  border: 1px solid #ece5e7;
  background: #ffffff;
  font-family: 'Montserrat', sans-serif;
  cursor: pointer;
  transition: .3s;
  color:rgb(45, 63, 56);
}

.btn-idioma:hover{
  transform: translateY(-2px);
  background: #f7eaea;
}

/* ===== RESPONSIVE ===== */
@media(max-width:480px){
  .invitacion-card{
    padding: 60px 16px;
  }

  .subtitulo{
    font-size: 2.4rem;
  }

  /* Ajuste leve para pétalos en móvil si se salen mucho */
  .petalo-izquierdo {
    left: -10px;
    width: 60px;
  }
  .petalo-derecho {
    right: -15px;
    width: 60px;
  }
}


.inicial-script {
  font-family: 'Pinyon Script', 'Great Vibes', cursive;
  font-size: 75px;
  font-weight: 400;
  display: inline-block;
  transform: translateY(18px) translateX(10px); /* Ajuste para envolver la siguiente letra */
  margin-right: 20px;
  margin-top:40px;
}

.resto-nombre {
  font-family: 'Cormorant Garamond', 'Cinzel', serif;
  font-size: 23px;
  font-weight: 300;
  letter-spacing: 6px;
}

</style>